import { AxiosError } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { getInstallments, getMySubscription } from '../../infrastructure/api/subscriptionsApi';
import { qKeys } from './keys';
import { queryDefaults } from './queryPolicy';

/** E07 — GET /subscriptions/my */
export function useMySubscription() {
  const query = useQuery({ queryKey: qKeys.subscription, queryFn: getMySubscription, ...queryDefaults });
  const isNoSubscription = (query.error as AxiosError)?.response?.status === 404;
  return { ...query, isNoSubscription };
}

/** E08 — GET /subscriptions/:id/installments (enabled only once the id is known). */
export function useInstallments(subscriptionId: string | undefined) {
  return useQuery({
    queryKey: qKeys.installments(subscriptionId ?? 'pending'),
    queryFn: () => getInstallments(subscriptionId as string),
    ...queryDefaults,
    enabled: Boolean(subscriptionId),
  });
}
